var React = require('react');

function Quote (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.0571 0.399902C12.6571 2.3999 0.857056 14.7999 0.857056 28.1999C0.857056 37.5999 6.65706 43.9999 13.4571 43.9999C18.4571 43.9999 22.4571 40.9999 22.4571 35.3999C22.4571 32.3999 20.8571 28.3999 15.2571 27.1999C12.2571 26.5999 8.65705 24.5999 8.65705 20.3999C8.65705 12.3999 19.0571 5.3999 26.8571 3.5999L26.0571 0.399902ZM55.6571 0.399902C42.2571 2.3999 30.4571 14.7999 30.4571 28.1999C30.4571 37.5999 36.2571 43.9999 43.0571 43.9999C48.0571 43.9999 52.0571 40.9999 52.0571 35.3999C52.0571 32.3999 50.4571 28.3999 44.8571 27.1999C41.8571 26.5999 38.2571 24.5999 38.2571 20.3999C38.2571 12.3999 48.6571 5.3999 56.4571 3.5999L55.6571 0.399902Z","fill":"#AA9A85"}));
}

Quote.defaultProps = {"width":"57","height":"44","viewBox":"0 0 57 44","fill":"none"};

module.exports = Quote;

Quote.default = Quote;
